import { useMutation } from '@tanstack/react-query';
import { ClinicMasterProduct } from '../types';
import { updateClinicMasterProduct } from '../requests';

type UpdateClinicMasterProduct = (id: string, data: ClinicMasterProduct) => Promise<ClinicMasterProduct>;

interface UseCreateClinicMasterProductReturn {
  updateClinicMasterProduct: UpdateClinicMasterProduct;
  isLoading: boolean;
}

export const useUpdateClinicMasterProduct = (): UseCreateClinicMasterProductReturn => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ([clinicMasterProductId, clinicMasterProduct]: [string, ClinicMasterProduct]) =>
      updateClinicMasterProduct(clinicMasterProductId, clinicMasterProduct)
  });

  const updateClinicMasterProductCallback = async (
    clinicMasterProductId: string,
    clinicMasterProduct: ClinicMasterProduct
  ) => {
    const response = await mutateAsync([clinicMasterProductId, clinicMasterProduct]);
    return response.data.data;
  };

  return {
    updateClinicMasterProduct: updateClinicMasterProductCallback,
    isLoading
  };
};
